'use client';

import { useEffect, useState } from 'react';

import { AnimatePresence, motion } from 'framer-motion';
import { useTranslations } from 'next-intl';

import { usePathname } from 'next/navigation';

import { LoadingAnimation } from '../loading';

export function Preloader() {
    const [isLoading, setIsLoading] = useState(true);
    const pathname = usePathname();

    useEffect(() => {
        // Проверяем, загружена ли страница
        if (document.readyState === 'complete') {
            const timer = setTimeout(() => {
                setIsLoading(false);
            }, 1950); // Минимальное время показа прелоадера
            return () => clearTimeout(timer);
        } else {
            // Если страница еще загружается, ждем событие load
            const handleLoad = () => {
                setTimeout(() => {
                    setIsLoading(false);
                }, 1500);
            };

            window.addEventListener('load', handleLoad);
            return () => window.removeEventListener('load', handleLoad);
        }
    }, []);

    // Сбрасываем состояние загрузки при изменении маршрута
    useEffect(() => {
        setIsLoading(true);
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, [pathname]);

    const t = useTranslations();

    return (
        <AnimatePresence>
            {isLoading && (
                <motion.div
                    className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background"
                    initial={{ opacity: 1 }}
                    exit={{
                        opacity: 0,
                        transition: {
                            duration: 0.8,
                            ease: 'easeInOut',
                        },
                    }}
                    // Предотвращаем взаимодействие с элементами под прелоадером
                    style={{ pointerEvents: 'all' }}
                >
                    <LoadingAnimation />

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{
                            opacity: 1,
                            y: 0,
                            transition: {
                                delay: 0.3,
                                duration: 0.5,
                            },
                        }}
                        className="mt-6 text-center"
                    >
                        <h2 className="text-xl font-medium text-primary">metalogic</h2>
                        <p className="mt-2 text-sm text-muted-foreground">{t('Loader.zagruzkaSaita')}...</p>

                        {/* Индикатор прогресса */}
                        <motion.div className="mt-4 h-1 w-48 overflow-hidden rounded-full bg-muted">
                            <motion.div
                                className="h-full bg-primary"
                                initial={{ width: 0 }}
                                animate={{
                                    width: '100%',
                                    transition: { duration: 2, ease: 'easeInOut' },
                                }}
                            />
                        </motion.div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
